import React from 'react';
import {initialState, VacationReportSearchContext} from './context';

const VacationReportSearchProvider = (props: { children: React.ReactNode }) => {
    const [state, setState] = React.useState(initialState);

    const config: VacationReportSearchContext = {
        ...initialState,
        ...state,
        change: (value) => setState((v) => ({ ...v, value })),
    }

    return <VacationReportSearchContext.Provider value={config}>
        {props.children}
    </VacationReportSearchContext.Provider>
}

export const useVacationReportSearch = (): VacationReportSearchContext => React.useContext(VacationReportSearchContext);

export default VacationReportSearchProvider;